import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const questionLibraryUrl = `${apiUrl}questionLibrary`;

export const requestGetQuestions = (includeInactive) =>
    axios.get(`${questionLibraryUrl}/questions?includeInactive=${includeInactive}`);

export const requestGetQuestionById = (questionId) =>
    axios.get(`${questionLibraryUrl}/questions/${questionId}`);

export const requestCreateQuestion = (data) =>
    axios.post(`${questionLibraryUrl}/questions`, data);

export const requestUpdateQuestionById = (id, data) =>
    axios.put(`${questionLibraryUrl}/questions/${id}`, data);

export const requestDeleteQuestion = (id) =>
    axios.delete(`${questionLibraryUrl}/questions/${id}`);

export const requestGetHeaders = (jobId, includeInactive) => {
    let query = `includeInactive=${includeInactive}`;
    if (jobId) {
        query += `&jobId=${jobId}`;
    }
    return axios.get(`${questionLibraryUrl}/headers?${query}`);
};

export const requestGetHeaderById = (headerId) =>
    axios.get(`${questionLibraryUrl}/headers/${headerId}`);

export const requestCreateHeader = (data) =>
    axios.post(`${questionLibraryUrl}/headers`, data);

export const requestUpdateHeaderById = (id, data) =>
    axios.put(`${questionLibraryUrl}/headers/${id}`, data);

export const requestDeleteHeaderById = (id) =>
    axios.delete(`${questionLibraryUrl}/headers/${id}`);
